<template functional>
  <form
    class="relative flex flex-col bg-white border rounded shadow border-grey-300"
    v-bind="data.attrs"
    :class="$options.methods.mergeFunctionalRenderContextClasses(data)"
    v-on="{
      ...listeners,
      submit: (event) => {
        event.preventDefault()

        if (!listeners.submit) return

        listeners.submit(event)
      },
    }"
  >
    <mia-fade-transition mode="out-in">
      <div
        v-if="props.isLoading"
        key="is-loading"
        class="absolute inset-0 flex items-center justify-center bg-gray-300"
      >
        <mia-wave-loader />
      </div>
      <div
        v-else
        key="has-loaded"
        class="flex flex-col justify-between flex-1"
      >
        <div :class="{ 'rounded-b': !slots().actions }">
          <slot />
        </div>
        <div
          v-if="slots().actions"
          class="flex items-center justify-end p-4 bg-gray-100 rounded-b"
        >
          <slot name="actions" />
        </div>
      </div>
    </mia-fade-transition>
  </form>
</template>

<script>
import { mergeFunctionalRenderContextClasses } from '@/helpers/utils'

export default {
  name: 'MiaForm',

  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    mergeFunctionalRenderContextClasses
  }
}
</script>
